import React, { useEffect, useMemo, useState } from 'react';
import { inject } from 'mobx-react';
import { useLocation } from 'react-router-dom';

import { unwrapContentfulFields } from 'common/components';
import { getCookie } from 'utils/helpers/cookie';

import FloatingWidget from './FloatingWidget';
import useFloatingWidgetTrigger from './useFloatingWidgetTrigger';
import { DISMISS_COOKIE_PREFIX, matchesPath } from './utils';

import './floating-widget.less';

function FloatingWidgetContainer({ externalObjects }) {
  const location = useLocation();
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    let cancelled = false;

    externalObjects
      .search({
        source: 'contentful',
        objectType: 'floatingWidget',
      })
      .then(({ data }) => {
        if (cancelled) return;
        setEntries(
          (data || []).map((item) => unwrapContentfulFields(item.object))
        );
      })
      .catch((error) => {
        console.error('Error fetching floating widgets:', error);
      });

    return () => {
      cancelled = true;
    };
  }, [externalObjects]);

  const entry = useMemo(() => {
    return entries.find((item) =>
      matchesPath(item?.fields?.paths, location.pathname)
    );
  }, [entries, location.pathname]);

  const id = entry?.sys?.id;

  const isDismissed = useMemo(() => {
    return Boolean(id && getCookie(`${DISMISS_COOKIE_PREFIX}${id}`));
  }, [id]);

  const { phase, expand, collapse, dismiss } = useFloatingWidgetTrigger({
    id,
    enabled: Boolean(entry) && !isDismissed,
    appearanceScroll: entry?.fields?.appearanceScroll,
    appearanceSeconds: entry?.fields?.appearanceSeconds,
    expandTimer: entry?.fields?.expandTimer,
  });

  if (!entry || isDismissed) return null;

  return (
    <FloatingWidget
      entry={entry}
      phase={phase}
      onExpand={expand}
      onCollapse={collapse}
      onDismiss={dismiss}
    />
  );
}

export default inject('externalObjects')(FloatingWidgetContainer);
